module.exports = __webpack_public_path__ + "components/country-flag/static/pg-a9b05786c76f9890993c4a7ad35a652d.svg";